import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./header and footer/Footer";
import "./css/style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faHeadset,
  faCircleQuestion,
  faPaperPlane,
  faSpinner,
  faChevronDown,
  faCheckCircle,
  faClock,
  faComments
} from "@fortawesome/free-solid-svg-icons";

function FAQItem({ question, answer, defaultOpen = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return (
    <div className={`accordion-item ${isOpen ? "open" : ""}`}>
      <button className="accordion-header" onClick={() => setIsOpen(!isOpen)}>
        <h3>
          <FontAwesomeIcon icon={faCircleQuestion} style={{ color: "#2563eb" }} />
          {question}
        </h3>
        <FontAwesomeIcon icon={faChevronDown} className="chevron" />
      </button>
      <div className="accordion-body">
        <div className="accordion-body-inner"><p>{answer}</p></div>
      </div>
    </div>
  );
}

function Contact() {
  const [formData, setFormData] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); }),
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );
    document.querySelectorAll(".reveal, .reveal-stagger").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSent(true);
      setFormData({ name: "", email: "", subject: "", message: "" });
      setTimeout(() => setSent(false), 5000);
    }, 1200);
  };

  const faqs = [
    { q: "How do I enroll in a course?", a: "Simply create a free account, browse our course catalog, and click 'Explore Course'. You will get immediate access to all course materials including video lectures, quizzes, and discussion forums." },
    { q: "Are the certificates recognized by employers?", a: "Yes! Our certificates are recognized by employers across 180+ countries. Each certificate includes a unique verification code that employers can use to verify your achievement." },
    { q: "Can I learn at my own pace?", a: "Absolutely. All our courses are self-paced, meaning you can learn anytime, anywhere. There are no rigid deadlines — take as long as you need to complete each module and assessment." },
    { q: "How do I become an instructor?", a: "Visit our 'Register' page and select the 'Become an Instructor' tab. Fill out the application form with your qualifications and area of expertise. Our team will review your application within 5-7 business days." },
    { q: "What payment methods do you accept?", a: "We accept all major credit/debit cards, PayPal, bank transfers, and regional payment methods. All transactions are secured with industry-standard encryption." },
    { q: "Is there a refund policy?", a: "Yes, we offer a 14-day refund policy if less than 30% of the course has been accessed. Visit our Resources page for full details on our refund policy." },
  ];

  return (
    <div>
      <Navbar page={"contact"} />

      <div className="page-banner">
        <h1>Contact Us</h1>
        <p>Have questions? We are here to help. Reach out to our team anytime.</p>
      </div>

      {/* Contact Form & Info */}
      <section style={{ padding: "80px 8%" }}>
        <div className="contact-grid reveal">
          {/* Contact Form */}
          <div className="contact-form-card">
            <h3>
              <FontAwesomeIcon icon={faPaperPlane} style={{ color: "#2563eb", marginRight: "10px" }} />
              Send Us a Message
            </h3>
            
            {sent && (
              <div className="auth-success-message" style={{ background: "rgba(16, 185, 129, 0.12)", border: "1px solid rgba(16, 185, 129, 0.25)", color: "#059669" }}>
                <FontAwesomeIcon icon={faCheckCircle} />
                <span>Message sent successfully! We will get back to you shortly.</span>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Full Name *</label>
                <input type="text" placeholder="John Doe" value={formData.name} required
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Email Address *</label>
                <input type="email" placeholder="john@example.com" value={formData.email} required
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Subject *</label>
                <input type="text" placeholder="How can we help?" value={formData.subject} required
                  onChange={(e) => setFormData({ ...formData, subject: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Message *</label>
                <textarea placeholder="Tell us more about your inquiry..." value={formData.message} required
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })} />
              </div>
              <button type="submit" className="btn-primary" disabled={loading} style={{ width: "100%", justifyContent: "center", padding: "14px", border: "none", cursor: loading ? "wait" : "pointer" }}>
                {loading ? (<><FontAwesomeIcon icon={faSpinner} spin /> Sending...</>) : (<>Send Message <FontAwesomeIcon icon={faPaperPlane} /></>)}
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="contact-info-cards">
            <div className="contact-info-card">
              <div className="info-icon"><FontAwesomeIcon icon={faEnvelope} /></div>
              <div>
                <h4>Email Us</h4>
                <a href="mailto:info@consortiumelearning.com">info@consortiumelearning.com</a>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="info-icon" style={{ background: "#e0f2fe", color: "#0284c7" }}><FontAwesomeIcon icon={faPhone} /></div>
              <div>
                <h4>Call Us</h4>
                <a href="tel:+442079460912">+44 (0) 20 7946 0912</a>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="info-icon" style={{ background: "#fef3c7", color: "#d97706" }}><FontAwesomeIcon icon={faMapMarkerAlt} /></div>
              <div>
                <h4>Head Office</h4>
                <p>6660 Kennedy Road, Suites 201 & 205, Mississauga, Ontario L5T 2M9 Canada</p>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="info-icon" style={{ background: "#d1fae5", color: "#059669" }}><FontAwesomeIcon icon={faClock} /></div>
              <div>
                <h4>Office Hours</h4>
                <p>Monday – Friday: 9:00 AM – 6:00 PM (EST)</p>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="info-icon" style={{ background: "#e0f2fe", color: "#0284c7" }}><FontAwesomeIcon icon={faHeadset} /></div>
              <div>
                <h4>Support Center</h4>
                <p>24/7 online support through our knowledge base and help center</p>
              </div>
            </div>

            <div className="contact-info-card">
              <div className="info-icon" style={{ background: "#dbeafe", color: "#2563eb" }}><FontAwesomeIcon icon={faComments} /></div>
              <div>
                <h4>Community Forum</h4>
                <p>Join discussions with fellow learners and get peer support</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section style={{ padding: "80px 8%", background: "#f8fafc" }}>
        <div className="reveal" style={{ textAlign: "center", marginBottom: "48px" }}>
          <h2 style={{ fontFamily: "'Outfit', sans-serif", fontSize: "2.2rem", fontWeight: 800, color: "#0f172a", marginBottom: "8px" }}>
            Frequently Asked Questions
          </h2>
          <p style={{ color: "#64748b", fontSize: "1.05rem", maxWidth: "600px", margin: "0 auto" }}>
            Find quick answers to common questions
          </p>
        </div>

        <div style={{ maxWidth: "800px", margin: "0 auto" }} className="reveal">
          {faqs.map((faq, i) => (
            <FAQItem key={i} question={faq.q} answer={faq.a} defaultOpen={i === 0} />
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Contact;
